// third-party
import { Dashboard, GridGoldenratioOutlined } from "@mui/icons-material";

const icons = {
    dashboard: Dashboard,
    components: GridGoldenratioOutlined
};

// ==============================|| MENU ITEMS - API ||============================== //

export const Menu = (menu) => {

    const SubChildrenLis = (SubChildrenLis) => {
        return SubChildrenLis?.map((subList) => {
            return {
                ...subList,
                title: `${subList.title}`,
                icon: icons[subList.icon]
            };
        });
    };

    const itemList = (subList) => {
        let list = {
            ...subList,
            title: `${subList.title}`,
            icon: icons[subList.icon]
        };

        if (subList.type === 'collapse') {
            list.children = SubChildrenLis(subList.children);
        }
        return list;
    };

    const withoutMenu = menu?.children?.filter((item) => item.id !== 'no-menu');

    const ChildrenList = withoutMenu?.map((subList) => {
        return itemList(subList);
    });

    return {
        ...menu,
        title: `${menu.title}`,
        icon: icons[menu.icon],
        children: ChildrenList
    };
};
